import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const FAQS = [
  {
    q: "Does this mean I have to get a brand new website?",
    a: "No, not necessarily. Our ADA code can be installed on pretty much most any platform. However, now that AI has taken over 70% of searches and recommendations, you should want to consider getting an audit done to see how badly your website maybe out of date.",
  },
  {
    q: "Q: Will this guarantee my website is 100% ADA compliant?",
    a: "A: It is a major step in the right direction! Because true digital accessibility requires continuous monitoring and the ADA doesn't issue official website stamps of approval, no software can promise absolute perfection. However, our ADA software solution substantially reduces down to a very minor risk. When actively removing barriers using user accessibility toolbars, pinpoint common vulnerabilities with smart scanning, and fix underlying code. So long as you have the ADA legal statement on your website you should not have a worry.",
  },
  {
    q: "Does the toolbar alone protect me from lawsuits?",
    a: "No. About 1 in 4 sites sued in 2025 already had a widget installed. Fixing the actual code — labels, headings, color contrast, alt text and keyboard access — makes the biggest difference. That's why every plan includes real fixes, not just a toolbar.",
  },
  {
    q: "What does the free scan actually check?",
    a: "The instant pre-check on this page runs a real analysis of your homepage: alt text, form labels, language, headings, buttons and more. After you request it, you get the full scan — up to 25 pages tested with axe-core against WCAG 2.2 A/AA — with a 0–100 score, every error explained in plain English, and code examples for the fixes.",
  },
  {
    q: "Is the tax credit real?",
    a: "Yes. The IRS Disabled Access Credit (Form 8826) is for eligible small businesses — generally $1 million or less in gross receipts, or 30 or fewer full-time employees. It covers 50% of eligible accessibility costs over $250, up to a $5,000 credit per year. We aren't tax advisors, so confirm with your tax professional.",
  },
  {
    q: "I'm a small business — am I really a target?",
    a: "64% of 2025 website accessibility lawsuits named companies with under $25 million in yearly revenue, and a business can be sued in a state where it has no office. The good news: small sites are usually quick and affordable to improve. Start with the free scan.",
  },
];

export const FAQ = () => (
  <section id="faq" className="py-24 sm:py-32">
    <div className="mx-auto max-w-4xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>STRAIGHT ANSWERS,<br />NO FINE PRINT</Eyebrow>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl leading-[1.02] text-white">
          QUESTIONS OWNERS <span className="text-cy">ACTUALLY ASK.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-10">
        <Accordion type="single" collapsible className="rounded-2xl border border-white/10 bg-panel px-6">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-white/10">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-5 text-left text-base sm:text-lg font-semibold text-white hover:no-underline hover:text-brandamber">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm sm:text-base leading-relaxed text-slate-400" data-testid={`faq-content-${i}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
      <Reveal delay={0.15} className="mt-14 text-center">
        <p
          data-testid="faq-if-when-banner"
          className="animate-blink font-display text-3xl sm:text-5xl font-extrabold text-alert"
          style={{ textShadow: "0 0 30px rgba(255,59,48,0.35)" }}
        >
          REMEMBER: IT'S NOT A MATTER OF IF — BUT WHEN.
        </p>
      </Reveal>
    </div>
  </section>
);
